import {PayloadAction} from "@reduxjs/toolkit";

export interface OptimizationState {
    imgInProgress: {[id: string]: boolean}
    imgURL: {[id: string]: boolean}
}

export var imgData: {[id: string]: string} = {}

export enum OptimizationActionType {
    SETINPROGRESS = "SETOPTIMIZATIONINPROGRESS",
    ADDIMGURL = "ADDOPTIMIZATIONIMGURL",
}

export type SetOptimizationImgInProgressAction = PayloadAction<string, OptimizationActionType.SETINPROGRESS>
export type AddOptimizationImgUrlAction = PayloadAction<{id: string, url: string}, OptimizationActionType.ADDIMGURL>

export type OptimizationAction = SetOptimizationImgInProgressAction | AddOptimizationImgUrlAction